<div class="description-recruitment-config">
  <div class="mt-2 d-flex align-items-center justify-content-between gap-2" >
    <p class="mb-0">{{'kich_thuoc' | translate}}:</p>
    <mat-form-field title="Size" style="width: 50%" >
      <mat-label> {{'kich_thuoc' | translate}}</mat-label>
      <input  
      (blur)="updateClass()" 
      matInput
      type="number" 
      [ngModel]="class['description-recruitment__editor']['font-size'] | vhnumber"
      (ngModelChange)="class['description-recruitment__editor']['font-size'] =$event + 'px'" />
    </mat-form-field>
  </div>
  
  <!-- Khoảng cách dòng -->
  <ng-container>
    <div class="d-flex align-items-center justify-content-between gap-2">
      <p class="mb-0" style="width: 50%;">{{'khoang_cach_dong' | translate}}</p>
      <nz-input-number [nzMin]="0.5" [nzMax]="3" [nzStep]="0.1"
        [(ngModel)]="class['description-recruitment__editor']['line-height']" (nzBlur)="updateClass()">
      </nz-input-number>
    </div>
    <nz-row>
      <nz-col nzSpan="24">
        <nz-slider [nzMin]="0.5" [nzMax]="3" [nzStep]="0.1"
          [(ngModel)]="class['description-recruitment__editor']['line-height']" (nzOnAfterChange)="updateClass()">
        </nz-slider>
      </nz-col>
    </nz-row>
  </ng-container>

  <div class="view-type">
    <p class="view-type__title">{{'kieu_hien_thi' | translate}}:</p>
    <nz-select 
    [(ngModel)]="class['description-recruitment']['overflow-y']" 
    (ngModelChange)="updateClass()"
  >
    <nz-option nzValue="auto" nzLabel="{{'cuon' | translate}}"></nz-option>
    <nz-option nzValue="hidden" nzLabel="{{'co_dinh' | translate}}"></nz-option>
  </nz-select>
  </div>
</div>